import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "css/jac.css";

import Sidebar from "js/AdminBoard/sideBar";
import OrganizationList from "js/AdminBoard/organizationList";
import AdminList from "js/AdminBoard/adminList";
import ManageList from "js/AdminBoard/manageList";
import TopBar from "js/Component/topBar";
import { fetchOrganization, logout } from "js/Api/index";

import CustomerSupport from "js/AdminBoard/CustomerSupportBoard/CustomerSupport";
import FeatureGroupList from "js/AdminBoard/FeatureGroups/FeatureGroupList"
import ImageManager from "js/AdminBoard/PuppyOfDay/ImageManager"

import "css/bootstrap.min.css";
import "css/style.css";
import "css/responsive.css";
import "css/color_2.css";
import "css/bootstrap-select.css";
import "css/perfect-scrollbar.css";
import "css/custom.css";
import "css/jquery.fancybox.css";
import MyProfile from "../Component/MyProfile/myProfile";

function Organise() {
    const [selectedMenu, setSelectedMenu] = useState("organizations");
    const [selectedOrg, setSelectedOrg] = useState(null);
    const [organizations, setOrganizations] = useState([]);
    const [admins, setAdmins] = useState([]);
    const [userInfo, setUserInfo] = useState(null);
    const [selectedTab, setSelectedTab] = useState("users");

    const navigate = useNavigate();
    const location = useLocation();

    const isSuperAdmin = userInfo?.role === "SuperAdmin";
    const isAdmin = userInfo?.role === "Admin";
    const isManager = userInfo?.role === "manager";
    const isStaff = userInfo?.role === "staff";

    useEffect(() => {
        const html = document.documentElement;
        const body = document.body;

        const prevHtmlOverflow = html.style.overflow;
        const prevBodyOverflow = body.style.overflow;

        html.style.overflow = "hidden";
        body.style.overflow = "hidden";

        return () => {
            html.style.overflow = prevHtmlOverflow;
            body.style.overflow = prevBodyOverflow;
        };
    }, []);

    useEffect(() => {
        const storedUserInfo = localStorage.getItem("userInfo");
        if (storedUserInfo) {
            try {
                const parsedUserInfo = JSON.parse(storedUserInfo);
                setUserInfo(parsedUserInfo);
            } catch (error) {
                console.error("Error parsing userInfo:", error);
                localStorage.removeItem("userInfo");
            }
        }
    }, []);

    useEffect(() => {
        if ((isStaff || isManager) && userInfo?.organizationGuid) {
            loadOrganization();
        }
    }, [isStaff, userInfo, isManager]);

    const loadOrganization = async () => {
        const result = await fetchOrganization(userInfo.organizationGuid);
        if (result.success) {
            setSelectedOrg(result.data);
        } else {
            console.log("Failed to fetch organization.");
        }
    };

    const handleBackClick = () => {
        setSelectedOrg(null);
    };

    const handleMenuClick = async (menu) => {
        if (menu === "logout") {
            navigate("/");
        } else if (menu === "organization") {
            await loadOrganization();
            navigate(location.pathname, { replace: true });
        } else {
            setSelectedMenu(menu);
            setSelectedOrg(null);
            navigate(location.pathname, { replace: true });
        }
    };

    const handleInviteAdmin = (newAdmin) => {
        setAdmins((prev) => [...prev, newAdmin]);
    };

    const handleDeleteAdmin = (adminId) => {
        setAdmins((prev) => prev.filter((admin) => admin.id !== adminId));
    };

    const handleUpdateAdmin = (updatedAdmin) => {
        setAdmins((prev) =>
            prev.map((admin) => (admin.id === updatedAdmin.id ? updatedAdmin : admin))
        );
    };

    const handleUpdateOrganization = (updatedOrg) => {
        setOrganizations((prev) =>
            prev.map((org) => (org.id === updatedOrg.id ? updatedOrg : org))
        );
    };

    const handleOrgClick = (org) => {
        setSelectedOrg(org);
    };

    const handleAddOrganization = (newOrg) => {
        setOrganizations((prev) => [...prev, newOrg]);
    };

    const handleDeleteOrganization = async (orgId) => {
        setOrganizations((prev) => prev.filter((org) => org.id !== orgId));
    };

    const handleLogout = async () => {
        try {
            const result = await logout();

            if (result.success) {
                localStorage.clear();
                navigate("/");
            } else {
                console.log("Logout failed:", result.error);
            }
        } catch (error) {
            console.log("Error:", error);
        }
    };

    const handleProfileBackClick = () => {
        navigate(location.pathname + location.search, { replace: true });
    };

    return (
        <div className="body-page">
            <Toaster />
            <Sidebar
                selectedMenu={selectedMenu}
                handleMenuClick={handleMenuClick}
                currentUserRole={userInfo?.role}
            />

      <div
        id="content"
        style={{
          height: "100vh",    
          overflowY: "auto",   
          overflowX: "hidden",
        }}
      >
              <TopBar userInfo={userInfo} onLogout={handleLogout} ShowTutorialUpdate={false} />

                <div
                    className="content"
                    style={{
                        paddingBottom: "24px",
                        overflow: "visible",
                    }}
                >
                    {selectedOrg && location.hash !== "#profile" && (
                        <ManageList
                            currentUserRole={userInfo?.role}
                            org={selectedOrg}
                            onBackClick={handleBackClick}
                            onUpdateOrganization={handleUpdateOrganization}
                            selectedTab={selectedTab}
                            setSelectedTab={setSelectedTab}
                        />
                    )}

                    {selectedMenu === "organizations" &&
                        !selectedOrg &&
                        location.hash !== "#profile" && (
                            <OrganizationList
                                organizations={organizations}
                                onOrgClick={handleOrgClick}
                                onAddOrganization={handleAddOrganization}
                                onDeleteOrganization={handleDeleteOrganization}
                                isAdmin={isAdmin}
                                isSuperAdmin={isSuperAdmin}
                            />
                        )}

                    {selectedMenu === "admins" &&
                        !selectedOrg &&
                        location.hash !== "#profile" && (
                            <AdminList
                                admins={admins}
                                onInviteAdmin={handleInviteAdmin}
                                onDeleteAdmin={handleDeleteAdmin}
                                onUpdateAdmin={handleUpdateAdmin}
                                isSuperAdmin={isSuperAdmin}
                                isStaff={isStaff}
                            />
                        )}

                    {selectedMenu === "customerSupport" &&
                        !selectedOrg &&
                        location.hash !== "#profile" && <CustomerSupport userInfo={userInfo} />}

                    {selectedMenu === "careWindowPlus" && !selectedOrg && location.hash !== "#profile" && <FeatureGroupList />}

                    {selectedMenu === "puppyOfDay" && !selectedOrg && location.hash !== "#profile" && <ImageManager />}

                    {location.hash === "#profile" && (
                        <MyProfile onBackClick={handleProfileBackClick} />
                    )}
                </div>
            </div>
        </div>
    );
}

export default Organise;